import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import searchIcon from './../../../../../Assets/icons/searchicon.svg';
import './index.scss';
import ListFilters from '../../OnBoardManagement/ListFilters';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TERMSET_TABLE_HEADERS, TERMSET_KEY_MAPPING } from '../../../../../constants/TermSetList';
import { setDayOfYear } from 'date-fns';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const TermsetList = () => {
  const [termsetData, setTermsetData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchTermsetData(newPage);
  };


  const fetchTermsetData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/termset/list',
        {
          orderBy: 'term_id desc',
          page,
          pageSize,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
        term_desc: item.term_desc.replace(/<\/?[^>]+(>|$)/g, "")
      }));
      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setTermsetData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching termset list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleEdit = (rowData) => {
    console.log("rowData",rowData);
    navigate('/admin/manage-termset/termset/edit-term', { state: { rowData } });
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchTermsetData();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div  className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Termset</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
       
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-termset/termset/add-term')}>
              Add Termset
            </button>
          </div>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Termset List</h5>
            <div>
              <SearchInput
                placeholder="Search Term"
                onSearch={fetchTermsetData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
              </div>
          </div>
        </div>

        <CustomTable 
          data={termsetData} 
          headers={TERMSET_TABLE_HEADERS} 
          keyMapping={TERMSET_KEY_MAPPING} 
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit} 
          totalRecords={totalRecords} 
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default TermsetList;
